export const siteInfo = {
  name: '爆料吃瓜',
  tag: '实时追踪 · 深度爆料',
  slogan: '你的每日娱乐八卦能量站',
  description: '爆料吃瓜网汇聚全网最新爆料与今日吃瓜实时瓜料，覆盖影视综艺、明星动态、网红圈层及社交热点，每日滚动更新热门八卦，以客观视角还原事件始末。平台以"快、准、全"为核心理念，为吃瓜群众提供一站式信息聚合体验，无论是追踪明星恋情进展、解析综艺争议名场面，还是挖掘行业幕后故事，这里都能满足你的好奇心与社交谈资需求。当前正值暑期档热播剧集中上线、多对CP营业话题持续发酵的高峰期，平台已集结千余条新鲜瓜料等你来翻。',
  stats: [
    { label: '今日更新', value: '200+ 条' },
    { label: '覆盖话题', value: '50+ 分类' },
    { label: '实时追踪', value: '7×24 小时' },
  ],
};

export const updatesData = [
  {
    id: 1,
    time: '15:32',
    tag: '独家',
    title: '某顶流男星被拍到深夜与神秘女子同回寓所，工作室暂未回应',
    source: '前线线人',
  },
  {
    id: 2,
    time: '14:18',
    tag: '热爆',
    title: '热门综艺录制现场突发冲突，两位导师因评分分歧当场翻脸',
    source: '现场观众',
  },
  {
    id: 3,
    time: '13:05',
    tag: '新瓜',
    title: '某85花被曝已低调离婚三个月，律师团队正在分割共同财产',
    source: '知情人士',
  },
  {
    id: 4,
    time: '11:42',
    tag: '追踪',
    title: '昨日爆料事件新进展：当事人表哥发文暗示另有隐情',
    source: '社交媒体',
  },
  {
    id: 5,
    time: '10:20',
    tag: '独家',
    title: '某古装剧剧组内部人员曝光片酬分配不均，男二片酬竟是男主两倍',
    source: '剧组工作人员',
  },
  {
    id: 6,
    time: '09:15',
    tag: '热爆',
    title: '知名网红直播间自曝被经纪公司压榨，哭诉三年零收入',
    source: '直播录屏',
  },
  {
    id: 7,
    time: '08:00',
    tag: '新瓜',
    title: '本周最期待：多位明星将在周五出席同一活动，修罗场预警',
    source: '活动官宣',
  },
];

export const indexData = [
  { id: 1, title: '本月热瓜排行榜', desc: '30天爆款瓜料TOP20，看看你漏了哪个', count: 20, icon: 'ri-fire-line' },
  { id: 2, title: '明星恋情追踪', desc: '2026年明星情侣动态全纪录', count: 35, icon: 'ri-heart-line' },
  { id: 3, title: '综艺名场面', desc: '各大综艺争议瞬间与未播花絮合集', count: 48, icon: 'ri-tv-line' },
  { id: 4, title: '网红塌房实录', desc: '头部网红翻车事件时间线整理', count: 16, icon: 'ri-alert-line' },
  { id: 5, title: '影视剧内幕', desc: '热门剧集选角内幕、幕后恩怨大起底', count: 27, icon: 'ri-film-line' },
  { id: 6, title: '品牌代言风云', desc: '明星代言签约、解约与翻车全记录', count: 22, icon: 'ri-vip-crown-line' },
  { id: 7, title: '圈内大佬揭秘', desc: '行业资深人士匿名分享的真实内幕', count: 13, icon: 'ri-spy-line' },
];

export const appData = {
  title: '随时随地 吃瓜不停',
  desc: '下载爆料吃瓜 App，推送快人一步，瓜料不再错过。支持 iOS 与 Android，覆盖手机、平板全场景。离线也能刷，通勤摸鱼两不误。',
  features: ['实时推送通知', '独家瓜料首发', '夜间模式护眼', '社区互动评论'],
};

export const mediaData = [
  {
    id: 1,
    title: '独家专访：圈内制片人揭秘选角黑幕',
    desc: '某知名制片人匿名接受采访，揭露行业选角背后的资本博弈与潜规则，信息量巨大。',
    duration: '12:45',
    views: '23.8万',
  },
  {
    id: 2,
    title: '全程回顾：本周最炸裂的五条爆料',
    desc: '一周瓜料精华盘点，从顶流恋情到剧组冲突，五分钟带你吃透本周所有大瓜。',
    duration: '05:32',
    views: '18.2万',
  },
  {
    id: 3,
    title: '粉丝必看：2026暑期档追星避雷指南',
    desc: '哪些明星值得追？哪些活动有坑？资深站姐分享多年追星经验与行业内幕。',
    duration: '08:17',
    views: '31.5万',
  },
];

export const cardsData = [
  {
    id: 1,
    title: '某选秀冠军被曝拖欠团队工资半年，经纪人已辞职',
    category: '明星财经',
    excerpt: '据多位工作人员透露，该艺人近半年商演不断，却以"资金周转"为由迟迟未结算团队薪酬，累计欠款或超百万。',
    tag: '独家',
  },
  {
    id: 2,
    title: '两部S+古装剧定档同一天，播出平台正面对打',
    category: '影视动态',
    excerpt: '业内人士分析，两部剧均投入过亿，主演阵容旗鼓相当，同天开播将直接争夺暑期档收视冠军。',
    tag: '热爆',
  },
  {
    id: 3,
    title: '某女团成员被拍到与已婚导演单独出行，粉丝后援会宣布暂停应援',
    category: '偶像圈',
    excerpt: '照片曝光后引发巨大争议，该成员社交媒体评论区已沦陷，经纪公司紧急召开内部会议。',
    tag: '新瓜',
  },
  {
    id: 4,
    title: '知名音乐人被实名举报抄袭，12首歌曲涉嫌侵权',
    category: '音乐圈',
    excerpt: '举报人提供了详细的对比分析报告，涉及多首年度热歌，若属实将面临巨额赔偿。',
    tag: '追踪',
  },
  {
    id: 5,
    title: '综艺节目组因安全措施不到位导致艺人受伤，节目暂停录制',
    category: '综艺现场',
    excerpt: '据现场观众描述，道具设置存在明显安全隐患，艺人摔倒后节目组未及时提供医疗救助。',
    tag: '热爆',
  },
];

export const aboutData = {
  title: '关于爆料吃瓜',
  paragraphs: [
    '爆料吃瓜网创立于2023年，是国内领先的娱乐八卦信息聚合平台。我们致力于为广大吃瓜群众提供最新、最快、最全的娱乐爆料与八卦资讯，覆盖影视综艺、明星名人、网红圈层及泛娱乐领域。',
    '平台坚持"客观还原、多方求证"的内容原则，每条爆料均标注信息来源与可信度等级，帮助用户在海量信息中辨别真伪。我们的编辑团队由资深娱乐记者、前艺人经纪及社交媒体分析师组成，确保内容的专业性与时效性。',
    '目前平台日均更新瓜料200余条，累计追踪话题超过500个，已成为中文互联网最具影响力的八卦信息集散地之一。',
  ],
};

export const topicsData = [
  { id: 1, name: '#某顶流恋情曝光', heat: '982万', trend: 'up' },
  { id: 2, name: '#综艺导师翻脸', heat: '756万', trend: 'up' },
  { id: 3, name: '#85花离婚传闻', heat: '623万', trend: 'hot' },
  { id: 4, name: '#片酬分配不均', heat: '541万', trend: 'up' },
  { id: 5, name: '#网红经纪压榨', heat: '498万', trend: 'up' },
  { id: 6, name: '#暑期档对打', heat: '437万', trend: 'new' },
  { id: 7, name: '#女团成员争议', heat: '415万', trend: 'hot' },
  { id: 8, name: '#音乐人抄袭举报', heat: '382万', trend: 'up' },
  { id: 9, name: '#综艺安全隐患', heat: '356万', trend: 'new' },
];

export const carouselData = [
  {
    id: 1,
    title: '暑期档最全追剧指南',
    desc: '15部热播剧全方位横评，哪部值得追？哪部该避雷？',
    category: '编辑精选',
  },
  {
    id: 2,
    title: '2026上半年塌房明星全纪录',
    desc: '从顶流到网红，那些翻车的人后来都怎么样了？',
    category: '年度盘点',
  },
  {
    id: 3,
    title: '娱乐圈资本局：谁在操控你看到的八卦？',
    desc: '深扒娱乐营销产业链，揭秘热搜背后的推手。',
    category: '深度调查',
  },
  {
    id: 4,
    title: '从练习生到顶流：一条价值十亿的流水线',
    desc: '偶像工业全链条解密，揭开造星背后的商业逻辑。',
    category: '行业观察',
  },
  {
    id: 5,
    title: '粉丝经济2.0：后援会的权力与金钱游戏',
    desc: '百万粉丝站的真实运作方式，钱都花去哪了？',
    category: '独家策划',
  },
  {
    id: 6,
    title: '吃瓜进化论：从天涯到微博到短视频',
    desc: '中国八卦文化的二十年变迁，吃瓜群众经历了什么？',
    category: '文化观察',
  },
];

export const contactData = {
  title: '爆料投稿 / 商务合作',
  desc: '如果你有独家线索、一手瓜料或行业猛料，欢迎通过以下方式联系我们。平台承诺对投稿人信息严格保密，采用后给予丰厚稿酬。',
  methods: [
    { icon: 'ri-mail-line', label: '投稿邮箱', value: 'tips@baguachigua.com' },
    { icon: 'ri-wechat-line', label: '微信爆料', value: 'bagua_tips' },
    { icon: 'ri-phone-line', label: '商务合作', value: '010-8888-6666' },
  ],
};

export const commentsData = [
  {
    id: 1,
    user: '吃瓜不嫌事大',
    avatar: '匿',
    time: '2小时前',
    content: '终于有人整理这些了！之前零零散散吃瓜总是漏掉关键信息，这个平台太方便了，已经推荐给姐妹群了。',
    likes: 1283,
  },
  {
    id: 2,
    user: '娱乐圈观察员',
    avatar: '观',
    time: '3小时前',
    content: '作为从业十年的娱乐记者，负责任地说这个平台的爆料准确率确实比同行高，很多信息和我们内部的线索能对上。',
    likes: 956,
  },
  {
    id: 3,
    user: '深夜吃瓜人',
    avatar: '夜',
    time: '5小时前',
    content: '那个综艺导师翻脸的视频我看了三遍！真的笑死，建议大家都去看看原片，表情管理完全失败。',
    likes: 2104,
  },
  {
    id: 4,
    user: '理性吃瓜群众',
    avatar: '理',
    time: '6小时前',
    content: '提醒大家吃瓜也要保持理性，有些爆料虽然刺激但可能是断章取义，等当事人回应再下结论不迟。',
    likes: 567,
  },
  {
    id: 5,
    user: '八卦小能手',
    avatar: '八',
    time: '8小时前',
    content: '每天上班第一件事就是打开爆料吃瓜看有没有新瓜，比刷微博有效率多了，编辑总结得特别好！',
    likes: 832,
  },
];

export const faqData = [
  {
    id: 1,
    q: '平台上的爆料信息可信吗？',
    a: '我们对每条爆料均标注信息来源与可信度等级。来自"前线线人""知情人士"等渠道的信息会经过多方交叉验证后发布；标注"独家"的内容为平台自采信息，可信度较高；标注"传闻"的则建议谨慎对待。我们始终建议读者理性吃瓜，等待官方回应。',
  },
  {
    id: 2,
    q: '如何向平台投稿爆料？',
    a: '可通过页面上方的"投稿合作"入口联系我们，或直接发送邮件至 tips@baguachigua.com。我们承诺对投稿人身份严格保密，采用后根据信息价值给予50-5000元不等的稿酬。',
  },
  {
    id: 3,
    q: '平台内容更新频率是怎样的？',
    a: '我们的编辑团队实行7×24小时轮班制，确保全天候覆盖最新瓜料。一般爆料事件发生后15分钟内即可上线快讯，深度追踪报道会在2小时内完成。',
  },
  {
    id: 4,
    q: '如果发现不实信息怎么办？',
    a: '我们设有专门的纠错机制。如果当事方或读者发现平台内容存在事实错误，可通过"投稿合作"通道提交更正申请及证明材料。经核实后，我们将在4小时内完成更正或撤稿，并发布更正说明。',
  },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '极速追踪',
    desc: '7×24小时不间断监控全网信息，重大事件发生后15分钟内上线快讯，确保你永远是第一个知道瓜的人。',
  },
  {
    id: 2,
    icon: 'ri-shield-check-line',
    title: '多方求证',
    desc: '每条爆料经过至少两个独立信息源交叉验证，标注可信度等级，帮你从海量信息中辨别真伪。',
  },
  {
    id: 3,
    icon: 'ri-stack-line',
    title: '专题聚合',
    desc: '复杂事件按时间线自动归集为专题合集，新来的吃瓜群众也能快速了解事件全貌，不再一头雾水。',
  },
  {
    id: 4,
    icon: 'ri-user-voice-line',
    title: '匿名保护',
    desc: '严格的投稿人信息保护机制，所有线人身份信息加密存储，绝不向第三方透露任何可识别信息。',
  },
];

export const rankingData = [
  { id: 1, rank: 1, title: '顶流恋情深夜密会全记录', heat: '982万', trend: 'up' },
  { id: 2, rank: 2, title: '综艺录制现场导师翻脸事件', heat: '756万', trend: 'up' },
  { id: 3, rank: 3, title: '85花离婚财产分割内幕', heat: '623万', trend: 'hot' },
  { id: 4, rank: 4, title: '古装剧片酬黑幕大揭秘', heat: '541万', trend: 'up' },
  { id: 5, rank: 5, title: '头部网红经纪压榨风波', heat: '498万', trend: 'new' },
];

export const navLinks = [
  { label: '关于我们', href: '#about' },
  { label: '热门话题', href: '#topics' },
  { label: '瓜料视频', href: '#media' },
  { label: '平台特色', href: '#features' },
  { label: '投稿合作', href: '#contact' },
];